import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'
import { toFilterOptions } from '@util/filter'

import { useStatusConfig } from '../../../status/hooks/useStatusConfig'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useHoofdleidingValuelists } from '../../../valuelists/hooks/useHoofdleidingValuelists'
import { useValuelists } from '../../../valuelists/hooks/useValuelists'
import { ActiviteitenFilters } from '../components/ActiviteitenFilters'
import { ActiviteitenTableRow } from '../components/ActiviteitenTableRow'
import { useActiviteitenSearch } from '../hooks/useActiviteitenSearch'

const headerCells = [
  { id: 'expired', numeric: false, label: '', fixed: 25 },
  { id: 'type', numeric: false, label: 'Type activiteit', fixed: 125 },
  { id: 'text', numeric: false, label: 'Opmerking' },
  {
    id: 'dueDate',
    numeric: false,
    label: 'Opleverdatum',
    fixed: 100,
    sort: true,
  },
  {
    id: 'created.date',
    numeric: false,
    label: 'Aangemaakt',
    fixed: 100,
    sort: true,
  },
  {
    id: 'created.organisatie',
    numeric: false,
    label: 'Aangemaakt door',
    fixed: 150,
    sort: true,
  },
  {
    id: 'assignedTo',
    numeric: false,
    label: 'Toegewezen aan',
    fixed: 150,
    sort: true,
  },
  { id: 'changed', numeric: false, label: 'Gewijzigd', fixed: 100, sort: true },
  { id: 'entity', numeric: false, label: 'Horend bij', fixed: 75, sort: true },
  { id: 'gemeente', numeric: false, label: 'Gemeente' },
  { id: 'gebiedscode', numeric: false, label: 'Gebied & labels', fixed: 100 },
  { id: 'actions', numeric: false, label: 'Details', fixed: 100 },
] as const

export const Activiteiten = () => {
  const { data: valuelists } = useValuelists()
  const { data: hoofdLeidingValuelists } = useHoofdleidingValuelists()
  const { data: statusConfig } = useStatusConfig()
  const {
    data: { items: activiteiten, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangeSort,
    onChangePage,
    filters,
    sort,
    onReset,
    onRefresh,
  } = useActiviteitenSearch()

  return (
    <Page
      title={['Activiteiten', 'Hoofdleiding']}
      breadcrumbs={[
        { label: 'Hoofdleiding', href: '/home', tooltip: 'CAPO home' },
        { label: 'Activiteiten' },
      ]}
      fillScreen
    >
      <PageSection id="activiteiten" heading="Overzicht van uw activiteiten" />

      <Paper>
        <ActiviteitenFilters
          onChange={onChangeFilters}
          filters={filters}
          initialFilters={initialFilters}
          onRefresh={onRefresh}
          onReset={onReset}
          filterOptions={{
            ...valuelists,
            hoofdleiding: hoofdLeidingValuelists,
            labels: toFilterOptions(hoofdLeidingValuelists.labels),
            processtappen: statusConfig.processtappenHoofdleiding,
          }}
        />
        <StyledTable
          onChangeSort={onChangeSort}
          onChangePage={onChangePage}
          headerCells={headerCells}
          sort={sort}
          stats={{ count, skip, limit }}
          loading={isLoading}
          isError={isError}
        >
          {activiteiten.map((activiteit) => {
            return (
              <ActiviteitenTableRow
                key={activiteit._id}
                activiteit={activiteit}
              />
            )
          })}
        </StyledTable>
      </Paper>
    </Page>
  )
}
